module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2026-02-16 at 21.42.51 (1).0bc22eb3.jpeg";